export const agencia = 1;

export const URL_SKIANDNIGHT = 'https://skiandnight.com';
export const URL_WSF = 'https://wsf.mygocu.com';
export const URL_SNOWDAZE = 'https://snowdaze.mygocu.com';
export const URL_FESTIVALHIBERNATION = 'https://festivalhibernation.mygocu.com';
export const URL_LANOCHEVOYAGES = 'https://lanochevoyages.mygocu.com';
export const URL_ATHLOSTRAVEL = 'https://athlostravel.mygocu.com';
